import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import * as FileSaver from 'file-saver';
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
//import styled, { css } from "styled-components";
import { addAnalytics, paginationAnalytics } from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var From_Date_val;
var to_Date_val;





const exportToCSVData = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);\
  var Heading = []
  if (fileName == "Inbound Receiving Detailed Report") {
    Heading = [['Batch', 'Invoice Number', 'ASN Number', 'PO Number', 'Client', 'Product Code', 'Product Name', 'MRP', 'UPC', 'Total Qty', 'Invoiced Qty', 'Received Qty', 'Received in CLD', 'Received in Loose','Received Short qty', 'PKM', 'PO Date', 'Inbound Del Date', 'Received Through', 'Receiving User', 'Product Scan Time', 'Pallet Scan Time(Start)', 'Pallet Scan Time (Complete)', 'Received Pallet ID', 'Remark', 'Status',]];
  }
  if (fileName == "Inbound Receiving Consolidated Report") {
    Heading = [['Batch', 'PO Date', 'Inbound Del Date', 'Invoice Number', 'ASN Number', 'PO Number', 'Client', 'Recieving completion percentage', 'SKU Count', 'Total Cld Count', 'Total Loose Count','Total Qty', 'Received Cld Qty', 'Received loose Qty','Total Received qty','Received Short qty', 'Recieving start time', 'Recieving End time', 'Assigned User Ids']];
  }
  exportToCSV(csvData, fileName, Heading)

}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.getSubGroupId = this.getSubGroupId.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.changeEAN = this.changeEAN.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.changeArticleId = this.changeArticleId.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.changeLongName = this.changeLongName.bind(this);
    this.changeShortName = this.changeShortName.bind(this);
    this.changeDesc = this.changeDesc.bind(this);
    this.changeSellingPrice = this.changeSellingPrice.bind(this);

    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showFromErr: false,
      showToErr: false,
      showFilter: false,
      ShowConfirmLoader: false,
      btnDisabled: true,
      isDisabledSearch: false,
      autoDesc: "",
      autoLongName: "",
      autoShortName: "",
      showConfirmError: false,
      autoCostPrice: "",
      autoSellingPrice: "",
      autoHsnCode: "",
      autoDesc: "",
      autoMargin: "",
      autoItemtype: "",
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      row_data: [],
      arr_data: [],
      Polaris: [],
      task_type: [],
      pack_size1: [],
      variant1: [],
      task: [],
      store: [],
      filtered_orderData: "",
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      color_variant: false,
      applyShelfLife: "",
      applyPackUOM: "",
      applyShelfUOM: "",
      applyTax: "",
      applyVariant: "",
      color_mrp: false,
      color_shelf: false,
      color_mc_code: false,
      color_brand: false,
      color_tax: false,
      color_ean: false,
      color_product: false,
      product_name_val: "",
      applyMrp: "",
      status_type: "1",
      bill_number: "",
      party_code: "",
      sku: "",
      apply: true,
      store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      longName: "",
      brand: "",
      mrp: "",
      ean: "",
      variant: "",
      shelf_life: "",
      image1: "",
      image2: "",
      image3: "",
      image4: "",
      image5: "",

      pack_unit: "",
      shelf_unit: "",
      showFetchDispatchData: false,
      showFetchDispatchData1: false,
      showfiltermsg : false,

      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",
      subStore: [],
      fromdate: "",
      todate: "",
      apply1: true,
      shelf_life_data: [],
      modal: false,
      modal1: false,
      modal2: false,
      modalFailed: false,
      showPackSize: false,
      showShelfLife: false,
      color_packSize: false,
      new_brand: "",
      new_pack_size: "",
      new_shelf_life: "",
      new_tax_percentage: "",
      new_variant: "",
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      autoShelfLife: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      detailed_view: true,
      consolidated_view: "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""
      // tableRowsMap :"",
    };
  }

  handleChange = (evt) => {
    if (evt.target.value == "detailed_view") {
      this.setState({ detailed_view: true, consolidated_view: false, tableRowsMap: [], tableRowsMap1: [], showFetchDispatchData1: false ,showfiltermsg :false })
    }
    else if (evt.target.value == "consolidated_view") {
      this.setState({ detailed_view: false, consolidated_view: true, tableRowsMap: [], tableRowsMap1: [], showFetchDispatchData: false, showfiltermsg :false })
    }

  }
  changeBrand = (evt) => {
    this.setState({
      brand_value: evt.target.value,
      brand: evt.target.value,
    });
  };
  changeArticleId = (evt) => {
    this.setState({
      article_id: evt.target.value,
    });
  };

  changeLongName = (evt) => {
    this.setState({
      autoLongName: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  changeShortName = (evt) => {
    this.setState({
      autoShortName: evt.target.value,
    });
  };

  changeDesc = (evt) => {
    this.setState({
      autoDesc: evt.target.value,
    });
  };

  changeSellingPrice = (evt) => {
    this.setState({
      autoSellingPrice: evt.target.value,
    });
  };

  changeCostPrice = (evt) => {
    this.setState({
      autoCostPrice: evt.target.value,
    });
  };
  onBillChange = (evt) => {
    this.setState({
      bill_number: evt.target.value,
    });
  };

  onUniqueCodeChange = (evt) => {
    this.setState({
      unique_code: evt.target.value,
    });
  };

  onSKUChange = (evt) => {
    this.setState({
      sku: evt.target.value,
    });
  };

  onCPChange = (evt) => {
    this.setState({
      cp_value: evt.target.value,
    });
  };

  onAsnChange = (evt) => {
    this.setState({
      asn_num: evt.target.value,
    });
  };

  onInvoiceChange = (evt) => {
    this.setState({
      invoice_num: evt.target.value,
    });
  };

  viewImage() {
    //window.open('/view_image','_blank');
    this.props.history.push("/npi_request_data");
  }

  changeMCCode = (evt) => {
    this.setState({
      mc_error: false,
      mc_code_value: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    this.fetchDispatch();
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  getVariant = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant1: response.data.data,
        });
      })
      .catch(function (error) { });
  };

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };


  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    console.log(today)
    From_Date_val = this.convertDate(today);
    to_Date_val = this.convertDate(today);

    //From_Date_val = today;
    //to_Date_val = today;

    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

    /* sessionStorage.setItem('store_id', this.state.store_id)
      sessionStorage.setItem('polaris_id', this.state.polaris_id)
      sessionStorage.setItem('status_type', this.state.status_type)
      sessionStorage.setItem('task_type_value', this.state.task_type_value)
      sessionStorage.setItem('task_id', this.state.task_id)
        }
        }
  */

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        fromdate: today,
        todate: today,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id'),
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id'),
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id'),
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type'),
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //  this.getSubGroupId();
        //this.fetchDispatch();
        //this.getStoreList();
        //this.getTaskList();
        //this.getMCCode();
        //this.getTaskTypeList();
        /*this.getVariant();
        this.getPacksize();*/
      }
    );

    //console.log("2n value")

    //localStorage.setItem('userName' , username);
    /*this.fetchDispatch();
      this.fetchDispatch();
      this.getStoreList();
      this.getTaskList();
      this.getPolarisList();
      this.getTaskTypeList();
      this.getVariant();
      this.getPacksize();*/
  }


  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
    this.setState({
      SuccessConfirmmodal: false,
    });

    window.location.reload();
    /*window.location.href="/putaway/printPutaway";*/
  }

  changeSubGroup = (e) => {
    this.setState({
      sub_group: e.target.value
    })
  }

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  getSubGroupId() {

    const payload = {
      screen_type: "packing_task_report"
    };

    API.post('/product/product_master/v1/subgroup/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        this.setState({ subStore: data.data });
      })

      .then(async () => {

      });
  }

  assembleDispatchData = (dispatchData) => {
    let DispatchData = dispatchData.map((post, index) => {

      return {
        batch: post.batch_number,
        invoice_number: post.invoice_number,
        asn_number: post.asn_number,
        po_number: post.po_number,
        client: post.client,
        product_code: post.product_code,
        product_name: post.product_name,
        mrp: post.mrp,
        upc: post.upc,
        total_qty: post.total_qty,
        invoice_qty: post.invoice_qty,
        received_qty: post.received_qty,
        received_cld: post.received_cld,
        received_loose: post.received_loose,
        received_short_qty : post.invoice_qty - post.received_qty,
        pkm: post.pkm,
        po_date: post.po_date,
        added_on: post.added_on,
        received_through: post.received_through,
        receiving_user: post.receiving_user,
        product_scan_time: post.product_scan_time,
        pallet_start_scan_time: post.pallet_start_scan_time,
        pallet_end_scan_time: post.pallet_end_scan_time,
        pallet_id: post.pallet_id,
        remark: post.remark,
        status: post.status

      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
      orderData: DispatchData,
      filtered_orderData: DispatchData
    });

    return DispatchData;
  };
  assembleDispatchData1 = (dispatchData) => {
    let DispatchData = dispatchData.map((post, index) => {

      return {
        batch: post.batch_number,
        po_date: post.po_date,
        inbound_del_date: post.inbound_del_date,
        invoice_number: post.invoice_number,
        asn_number: post.asn_number,
        po_number: post.po_number,
        client: post.client,
        receiving_completion_percentage: post.receiving_completion_percentage,
        sku_count: post.sku_count,
        total_cld_count: post.total_cld_count,
        total_loose_count: post.total_loose_count,
        total_qty : post.total_quantity,
        received_cld_count: post.received_cld_count,
        received_loose_count: post.received_loose_count,
        total_received_qty : post.received_qty,
        received_short_qty : post.total_quantity - post.received_qty,
        product_scan_timing: post.product_scan_timing,
        pallet_scan_timing: post.pallet_scan_timing,
        assigned_user: post.assigned_user,


      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
      orderData: DispatchData,
      filtered_orderData: DispatchData
    });

    return DispatchData;
  };

  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      "request_type": "download",
      "to_date": to_Date_val,
      "from_date": From_Date_val,
      "inbound_delivery_num": this.state.cp_value,
      "asn_num": this.state.asn_num,
      "invoice_num": this.state.invoice_num,
    };

    API.post('/receiving/receiving_report/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };


  fetchDispatch = (order_no) => {
    this.setState({
      //loading_overlay: true,
      loading: true,
    });
    var view_type = ""
    if (this.state.detailed_view == true) {
      view_type = "detailed_view"
    }
    else if (this.state.consolidated_view == true) {
      view_type = "consolidated_view"
    }
    const payload = {
      "request_type": "view",
      "view_type": view_type,
      "to_date": to_Date_val,
      "from_date": From_Date_val,
      "inbound_delivery_num": this.state.cp_value,
      "asn_num": this.state.asn_num,
      "invoice_num": this.state.invoice_num,
    };
    addAnalytics('Report', 'Recieving Report View', payload);

    API.post('/receiving/receiving_report/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          // showFetchDispatchData: true,
          loading: false
        });


        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            // showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          return false;
        }
        if (data.data_type == "detailed_data") {
          this.setState({
            // orderData: data.data,
            // filtered_orderData : data.data,
            tableRowsMap: this.assembleDispatchData(data.data),
            showFetchDispatchData: true,
            dispatch_status: false,
            showfiltermsg :true
          });

        }
        if (data.data_type == "consolidated_data") {
          this.setState({
            // orderData: data.data,
            // filtered_orderData : data.data,
            tableRowsMap1: this.assembleDispatchData1(data.data),
            showFetchDispatchData1: true,
            dispatch_status: false,
            showfiltermsg :true
          });
        }

        // this.setState({
        //   // orderData: data.data,
        //   // filtered_orderData : data.data,
        //   tableRowsMap: this.assembleDispatchData(data.data),
        //   showFetchDispatchData: true,
        //   dispatch_status: false,
        // });
      })
      .catch(function (error) { });
  };

  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal } = this.state;
    const { EditModal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Batch",

          field: "batch",
          width: 180,
        },
        {
          label: "Invoice Number",

          field: "invoice_number",
          width: 180,
        },
        {
          label: "ASN Number",

          field: "asn_number",
          width: 180,
        },
        {
          label: "PO Number",
          field: "po_number",
          width: 180,
        },
        {
          label: "Client",

          field: "client",
          width: 130,
        },
        {
          label: "Product Code",

          field: "product_code",
          width: 150,
        },
        {
          label: "Product Name",

          field: "product_name",
          width: 180,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 80,
        },
        {
          label: "UPC",
          field: "upc",
          width: 130,
        },
        {
          label: "Total Qty",

          field: "total_qty",
          width: 100,
        },
        {
          label: "Invoiced Qty",

          field: "invoice_qty",
          width: 100,
        },
        {
          label: "Received Qty",

          field: "received_qty",
          width: 100,
        },
        {
          label: "Received in Cld",
          field: "received_cld",
          width: 130,
        },
        {
          label: "Received in Loose",
          field: "received_loose",
          width: 130,
        },
        {
          label: "Received Short Qty",
          field: "received_short_qty",
          width: 130,
        },
        {
          label: "PKM",

          field: "pkm",
          width: 100,
        },
        {
          label: "PO Date",
          field: "po_date",
          width: 130,
        },
        {
          label: "Inbound Del Date",
          field: "added_on",
          width: 130,
        },
        {
          label: "Received Through",

          field: "received_through",
          width: 120,
        },
        {
          label: "Receiving User",

          field: "receiving_user",
          width: 150,
        },
        {
          label: "Product scan time",
          field: "product_scan_time",
          width: 130,
        },
        {
          label: "Pallet Scan time (Start)",

          field: "pallet_start_scan_time",
          width: 130,
        },

        {
          label: "Pallet Scan time (Complete)",
          field: "pallet_end_scan_time",
          width: 130,
        },

        {
          label: "Received Pallet ID",
          field: "pallet_id",
          width: 130,
        },
        {
          label: "Remark",

          field: "remark",
          width: 150,

        },
        {
          label: "Status",

          field: "status",
          width: 80,
        },
      ],

      rows: this.state.tableRowsMap,
    };
    const dispatchData1 = {
      columns: [
        {
          label: "Batch",

          field: "batch",
          width: 130,
        },
        {
          label: "PO Date",

          field: "po_date",
          width: 150,
        },
        {
          label: "Inbound Del Date",

          field: "inbound_del_date",
          width: 150,
        },
        {
          label: "Invoice Number",

          field: "invoice_number",
          width: 180,
        },
        {
          label: "ASN Number",

          field: "asn_number",
          width: 180,
        },
        {
          label: "PO Number",
          field: "po_number",
          width: 180,
        },
        {
          label: "Client",

          field: "client",
          width: 130,
        },

        {
          label: "Recieving completion percentage",

          field: "receiving_completion_percentage",
          width: 100,
        },
        {
          label: "SKU Count",
          field: "sku_count",
          width: 100,
        },
        {
          label: "Total Cld Count",

          field: "total_cld_count",
          width: 100,
        },
        {
          label: "Total Loose Count",

          field: "total_loose_count",
          width: 100,
        },
        {
          label: "Total Qty",

          field: "total_qty",
          width: 100,
        },
        {
          label: "Received Cld Qty",

          field: "received_cld_count",
          width: 100,
        },
        {
          label: "Received loose Qty",
          field: "received_loose_count",
          width: 100,
        },
        {
          label: "Total Received Qty",

          field: "total_received_qty",
          width: 100,
        },
        {
          label: "Received Short Qty",
          field: "received_short_qty",
          width: 130,
        },
        
        {
          label: "Recieving start time",
          field: "product_scan_timing",
          width: 130,
        },
        {
          label: "Recieving End time",

          field: "pallet_scan_timing",
          width: 130,
        },
        {
          label: "Assigned User Ids",
          field: "assigned_user",
          width: 180,
        },
      ],

      rows: this.state.tableRowsMap1,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <Overlay>
            <form className="form" onSubmit={handleSubmit}>
               <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                    <span className="filter_title">Filters</span>
                  </div>
              {(this.state.detailed_view || this.state.consolidated_view) &&
              <div>
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">From Date</span>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={this.state.from_date}
                      onChange={this.FromDateChange}
                      className="ledger_fromdate"
                      placeholderText="From Date"
                      format='yyyy-MM-dd'
                    />
                    {this.state.showFromErr &&
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                    }
                    {this.state.dateOrderError && (
                      <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                    )}
                  </div>
                  </div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">To Date</span>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={this.state.to_date}
                      onChange={this.ToDateChange}
                      className="ledger_todate"
                      placeholderText="To Date"
                    />
                    {this.state.showToErr &&
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                    }

                    {this.state.dateRangeError &&
                      <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                    }
                  </div>
                </div>
                </div>
              }
              {this.state.detailed_view &&

                <div>
                   <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Delivery Number</span>
                      <div style={{ position: 'relative' }}>
                      <input type="text" style={{ height: 38 }} className="form-control" placeholder="Delivery Number" onChange={this.onCPChange} />
                    </div>
                  </div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">ASN Number</span>
                      <div style={{ position: 'relative' }}>
                      <input type="text" style={{ height: 38 }} className="form-control" placeholder="ASN Number" onChange={this.onAsnChange} />
                    </div>
                  </div>
                 <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Invoice Number</span>
                      <div style={{ position: 'relative' }}>
                      <input type="text" style={{ height: 38 }} className="form-control" placeholder="Invoice Number" onChange={this.onInvoiceChange} />
                    </div>
                  </div>
                </div>

              }

             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">View Type</span>
                      <div style={{ position: 'relative' }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 190 }}
                    onChange={this.handleChange}
                  // name="year"               
                  >
                    <option value="detailed_view">Select View Type</option>
                    <option value="detailed_view">Detailed View </option>
                    <option value="consolidated_view">Consolidated View </option>
                  </select>
                </div>
              </div>

             <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                  <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginRight: '10px',
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>



              {(this.state.detailed_view &&

                 <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 10px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Inbound Receiving Detailed Report")}                >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                </Button>

              )}
              {(this.state.consolidated_view &&

                <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 25px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Inbound Receiving Consolidated Report")}              >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '25px' }} // Adjust size as needed
                    />
                    Download
                </Button>
              )}
               </ButtonToolbar>
               </div>
            </form>
          </Overlay>
          {!this.state.showfiltermsg&& (
                           <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
                              <img style={{width: '10%'}} src={EmptyDataIcon} />
                               <p className="noDataTextStyle">
                               Choose your filters from the available options. The data will display
                             </p>
                             <p className="noDataTextStyle2">
                                here once the filters have been applied.
                             </p>
                           </div>)} 
          {this.state.showFetchDispatchData && (
            <div>
            <div>

            <div className="date-container">
             {From_Date_val}
            </div>


            <div className="date-container">
             {to_Date_val}
            </div>

          </div>
            <div style={{ marginTop: 2, paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  displayEntries={false}
                  striped
                  bordered
                  onPageChange={(pageNumber) => paginationAnalytics(pageNumber.activePage, pageNumber.pagesAmount, 'Receiving Report', 'datatable_pagination_change')}
                  onSearch={this.filterData}
                  data={dispatchData}
                />
              </div>
            </div>
            </div>
          )}
          {this.state.showFetchDispatchData1 && (
            <div>
            <div>

            <div className="date-container">
             {From_Date_val}
            </div>


            <div className="date-container">
             {to_Date_val}
            </div>

          </div>
            <div style={{ marginTop: 2, paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  displayEntries={false}
                  striped
                  bordered
                  onPageChange={(pageNumber) => paginationAnalytics(pageNumber.activePage, pageNumber.pagesAmount, 'Receiving Report', 'datatable_pagination_change')}
                  onSearch={this.filterData}
                  data={dispatchData1}
                />
              </div>
            </div>
            </div>
          )}
        </Card>



      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));